module.exports = __webpack_public_path__ + "img/40_69_010_570.0bc7870c.jpg";